import { render, staticRenderFns } from "./DeskBar.vue?vue&type=template&id=282a7116&"
import script from "./DeskBar.vue?vue&type=script&lang=js&"
export * from "./DeskBar.vue?vue&type=script&lang=js&"
import style0 from "./DeskBar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports